/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { LoyaltyProgramSummaryV2Dto } from './loyaltyProgramSummaryV2Dto';
import { LocationInfoDto } from './locationInfoDto';


export interface ClientTransactionV2Dto { 
    id?: number;
    uuid?: string;
    created?: string;
    status?: ClientTransactionV2Dto.StatusEnum;
    errorMessage?: string;
    points?: number;
    finishedAt?: string;
    title?: string;
    details?: string;
    invoiceNo?: string;
    invoiceDate?: string;
    invoiceTime?: string;
    loyaltyProgram?: LoyaltyProgramSummaryV2Dto;
    location?: LocationInfoDto;
}
export namespace ClientTransactionV2Dto {
    export type StatusEnum = 'INITIALIZED' | 'SUCCESS' | 'VALIDATION_PENDING' | 'ERROR' | 'DECLINED' | 'REPORTED';
    export const StatusEnum = {
        Initialized: 'INITIALIZED' as StatusEnum,
        Success: 'SUCCESS' as StatusEnum,
        ValidationPending: 'VALIDATION_PENDING' as StatusEnum,
        Error: 'ERROR' as StatusEnum,
        Declined: 'DECLINED' as StatusEnum,
        Reported: 'REPORTED' as StatusEnum
    };
}


